import { isMobile } from '../../../services/DeviceInformation';
import RecentActivityDesktop from './RecentActivityDesktop';
import RecentActivityMobile from './RecentActivityMobile';

const RecentActivity = () => {
    if (isMobile()) {
        return <RecentActivityMobile />;
    }
    return <RecentActivityDesktop />;
};

export default RecentActivity;
